module.exports = __webpack_public_path__ + "media/images/logos/bamboo_hr-189e7f52d3fac6386f9a63717d94a938.png";